import { render, staticRenderFns } from "./WorldMap.vue?vue&type=template&id=0565798e&scoped=true"
import script from "./WorldMap.vue?vue&type=script&lang=js"
export * from "./WorldMap.vue?vue&type=script&lang=js"
import style0 from "./WorldMap.vue?vue&type=style&index=0&id=0565798e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0565798e",
  null
  
)

export default component.exports